import { css, styled } from 'canoe';

import { PALETTE_WIDTH } from 'craft/containers/Palette';
import { MediaBreakpoint, viewportWidth } from 'craft/types';

export const editorViewportNodeCss = css`
  .grid-column {
    grid-template-columns: repeat(auto-fit, minmax(0px, 1fr));
  }

  .collection-item {
    &--hidden {
      opacity: 0.2;

      &:not(.node-selected) {
        display: none !important;
      }
    }
  }

  b,
  strong {
    font-weight: bold;
  }
`;

// NOTE: vieport has a fix for bold font weight within editor
// due to the way we import google fonts
// TODO(mat) improve font imports
export const ViewportContainer = styled.div<{
  viewport: MediaBreakpoint;
  height?: string;
  isFullWidthSnapshot?: boolean;
}>`
  ${({ theme, viewport, height, isFullWidthSnapshot }) => css`
    width: ${viewportWidth(viewport)};
    ${isFullWidthSnapshot &&
    viewport === MediaBreakpoint.LG &&
    css`
      width: calc(100vw - ${PALETTE_WIDTH}px);
    `}

    min-height: 100%;
    ${height
      ? css`
          height: ${height};
        `
      : css`
          height: 100%;
        `}

    margin-left: auto;
    margin-right: auto;
    background-color: ${theme.colors.GlitterGrayL20};

    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 0;
    flex: 1;

    -webkit-font-smoothing: initial;

    .media-hidden-${viewport}:not(.node-selected) {
      display: none !important;
    }

    .media-hidden-${viewport}.node-selected {
      opacity: 0.2;
    }

    ${editorViewportNodeCss}
  `}
`;
